import { Ng2StateDeclaration } from '@uirouter/angular';

import { MonitoringFaultComponent } from './containers/monitoring-fault/monitoring-fault.component';
import { MonitoredTrainComponent } from './containers/monitored-train/monitored-train.component';
import { MonitoringOverviewComponent } from './containers/monitoring-overview/monitoring-overview.component';
import { MonitoringAlarmsComponent } from './containers/monitoring-alarms/monitoring-alarms.component';


export const monitoringOverviewState: Ng2StateDeclaration = {
    name: 'home',
    url: '/project/:projectId/overview',
    component: MonitoringOverviewComponent,
    params: {
        projectId: {squash: true, value: null}
    }
};

export const monitoringFaultState: Ng2StateDeclaration = {
    name: 'monitoring',
    url: '/project/:projectId/monitoring/:tab',
    component: MonitoringFaultComponent,
    params: {
        tab: {squash: true, value: null},
        projectId: {squash: true, value: null}
    }
};

export const monitoringAlarmsState: Ng2StateDeclaration = {
    name: 'monitoring-sections',
    url: '/project/:projectId/monitoring/custom-alarms/:alarmType',
    component: MonitoringAlarmsComponent,
    params: {
        alarmType: {squash: true, value: null},
        projectId: {squash: true, value: null}
    }
};

export const monitoringTrainDetailsState: Ng2StateDeclaration = {
    name: 'monitoring-detail',
    url: '/project/:projectId/monitoring-detail/train/:trainId/:tab',
    component: MonitoredTrainComponent,
    params: {
        tab: {squash: true, value: null},
        projectId: {squash: true, value: null},
        trainId: {squash: true, value: null}
    }
};

export const MONITORING_STATES = [
    monitoringFaultState,
    monitoringTrainDetailsState,
    monitoringOverviewState,
    monitoringAlarmsState
];
